/**
 * WordPress dependencies.
 */
import { __ } from '@wordpress/i18n';
import {
    PanelBody,
    SelectControl
} from '@wordpress/components';

/**
* Internal dependencies
*/

import {VayuBlocksDeviceControl } from '@vayu-blocks/device-control';
import { HeightControl,VayuBlocksRangeControl} from '@vayu-blocks';
import IconPicker from './iconpicker.js';

const SwiperSettingPanel = ({
            attributes,
            setAttributes,
            openPanels, 
			onTogglePanel ,
        }) => {

        return(
        <>
        <PanelBody 
        title={ __( 'Setting', 'vayu-blocks' ) }
        opened={openPanels['vb-swiper-set']} onToggle={() => onTogglePanel('vb-swiper-set')}
         >

                        <HeightControl
                            label={__('Slide Width', 'vayu-blocks')}
                            value={ attributes.swipeslideWidth }
                            onChange={ (value) => setAttributes({swipeslideWidth: value }) }
                            responsive={true}
                            customUnits={['px','%','em','vw']}
                            unitMax={{px:{max:2500, step:1}}}
                        />

                        <HeightControl
                            label={__('Content Width', 'vayu-blocks')}
                            value={ attributes.swipeStartGap }
                            onChange={ (value) => setAttributes({swipeStartGap: value }) }
                            responsive={true}
                            customUnits={['px','%','em','vw']}
                            unitMax={{px:{max:2500, step:1}}}
                        />

                        <HeightControl
                            label={__('Slide Gap', 'vayu-blocks')}
                            value={ attributes.swipeslideGap }
                            onChange={ (value) => setAttributes({swipeslideGap: value }) }
                            responsive={true}
                            customUnits={['px','%','em','vw']}
                            unitMax={{px:{max:2500, step:1}}}
                        />
                
                
                </PanelBody>
                <PanelBody 
                title={ __( 'Slider Navigation/Pagination', 'vayu-blocks' ) }
                 opened={openPanels['vb-swiper-nav']} onToggle={() => onTogglePanel('vb-swiper-nav')}
                >
                <SelectControl
                    label={__('Navigation/Pagination', 'vayu-blocks')}
                    value={attributes.swipeNav}
                    options={[
                            { label: __('Arrow & Dots', 'vayu-blocks'), value: 'arrowdots' },
                            { label: __('Arrow', 'vayu-blocks'), value: 'arrow' },
                            { label: __('Dots', 'vayu-blocks'), value: 'dots' },
                            { label: __('None', 'vayu-blocks'), value: 'none' },
                        ]}
                    onChange={(e) => setAttributes({ swipeNav: e })}
                 />
                 {(attributes.swipeNav === 'arrow' || attributes.swipeNav === 'arrowdots') && (
            <>
                <IconPicker
                label={__('Left Icon', 'vayu-blocks')}
                Icon={attributes.swipeNavIconLeft}
                onIconSelect={(icon) => {
                    setAttributes({ swipeNavIconLeft: icon });
                }}
                />
                <IconPicker
                label={__('Right Icon', 'vayu-blocks')}
                Icon={attributes.swipeNavIconRight}
                onIconSelect={(icon) => {
                    setAttributes({ swipeNavIconRight: icon });
                }}
                />
            </>
            )}

                             <VayuBlocksRangeControl	
                                label={<VayuBlocksDeviceControl label={__('Nav Size', 'vayu-blocks')} classname='bold' />}
                                min={0}
                                max={100}
                                step={1}
                                marks={false}
                                withInputField={true}
                                onChange={(key, value) => setAttributes({ [key]: value })}
                                attribute={{key:'swipeNavSize', value:attributes.swipeNavSize}}
                            />

                            <VayuBlocksRangeControl	
                                label={<VayuBlocksDeviceControl label={__('Nav Positon Left/Right', 'vayu-blocks')} classname='bold' />}
                                min={0}
                                max={100}
                                step={1}
                                marks={false}
                                withInputField={true}
                                onChange={(key, value) => setAttributes({ [key]: value })}
                                attribute={{key:'swipeNavPostion', value:attributes.swipeNavPostion}}
                            />

                            <VayuBlocksRangeControl	
                                label={<VayuBlocksDeviceControl label={__('Pagination Size', 'vayu-blocks')} classname='bold' />}
                                min={0}
                                max={100}
                                step={1}
                                marks={false}
                                withInputField={true}
                                onChange={(key, value) => setAttributes({ [key]: value })}
                                attribute={{key:'swipePagiSize', value:attributes.swipePagiSize}}
                            />

        </PanelBody>
        </>
    )

}
export default SwiperSettingPanel;